export const home = {
  home_profile_selector_text: 'Sélectionner un profil',
  home_profile_selector_subtitle: 'Choisissez votre profil pour continuer votre inscription.',
  home_has_account_true: 'Non, je participe déjà',
  home_has_account_false: "S'inscrire à l'étude !",
  home_is_new: "Êtes-vous nouveau ?",
  home_forgot_password: 'Mot de passe oublié ?',
  home_inscription_title: 'Inscription',
  home_consent_title: 'Consentement',
  home_consent_expired_title: 'Cette page de consentement a expiré',
  home_consent_expired_description: 'Elle est restée ouverte trop longtemps. Revenez à l\'étape précédente pour recharger le consentement et poursuivre votre inscription.',
  home_consent_item_required: 'obligatoire',
  home_consent_item_optional: 'facultatif',
  home_consent_items_mismatch: 'Le consentement a été mis à jour. Merci de relire et de valider à nouveau les cases à cocher.',
  home_content_check_text: 'En cochant cette case, je confirme être en accord avec toutes les modalités du document d\'information',
  home_content_none_text: 'Pas de consentement',
  //Ajout Syanekene
  home_not_consent_text: 'Je ne suis pas en accord avec toutes les modalités',
  home_content_signature_text: 'Signez ci-dessous pour donner votre consentement',
  home_inclusion_placeholder: 'Sélectionner',
  home_inclusion_answer_true: 'Oui',
  home_inclusion_answer_false: 'Non',
  home_inclusion_on: 'À propos de vous',
  home_inclusion_off: 'Pas de question d\'inclusion',
  home_identifier_title: 'Choisissez votre identifiant',
  home_contact_title: 'Vous contacter',
  home_contact_description: 'Pour que l\'étude marche, vous recevrez des rappels et des informations, au maximum 2 fois par mois.',
  home_inscription_identifier: 'E-mail ou pseudonyme',
  home_inscription_firstname: 'Prénom',
  home_inscription_lastname: 'Nom',
  home_inscription_nickname: 'Pseudonyme',
  home_inscription_email: 'Email',
  home_inscription_phone: 'Téléphone',
  home_inscription_external_id: 'Numéro de dossier',
  home_inscription_address: 'Adresse',
  home_inscription_birthdate: 'Date de naissance',
  home_inscription_off: 'Aucune identification',
  home_secret_questions: 'Questions secrètes',
  home_secret_question_date_placeholder: 'Choisir une date',
  home_secret_question_number_placeholder: 'Saisir un nombre',
  home_secret_question_text_placeholder: 'Saisir un texte',
  home_password_title: 'Créez votre mot de passe',
  home_password_placeholder: 'Mot de passe',
  home_password_placeholder_confirm: 'Confirmer le mot de passe',
  home_login_email_placeholder: 'Email',
  home_login_nickname_placeholder: 'Pseudonyme, email, ou téléphone',
  home_login_identifier_placeholder: 'Pseudonyme, email, téléphone ou numéro de dossier',
  home_login_file_placeholder: 'Saisir numéro de dossier',
  home_password_description: 'Le mot de passe doit faire au moins 8 caractères, et contenir des majuscules, des minuscules, des symboles et des chiffres.',
  home_login_title: 'Connexion',
  home_login_subtitle: 'Ravi de vous revoir !',
  home_login_incorrect: 'Votre identifiant ou mot de passe est incorrect.',
  home_login_too_many_attempts: 'Trop de tentatives de connexion. Pour votre sécurité, veuillez patienter quelques minutes avant de réessayer.',
  home_login_button: 'Se connecter',
  home_login_password_placeholder: 'Votre mot de passe',
  home_stratification_title: '',
  home_stratification_placeholder: 'Sélectionner',
  home_sites_text: 'Affection au site',
  home_subsites_text: 'Affection au sous-site',
  home_do_you_have_account: 'Vous avez un compte ?',
  home_researchers_website: 'Site des chercheurs',
  home_registred_successfully: 'Félicitations, vous êtes bien inscrit.',
  home_inscription_error_EMAIL_EXIST: 'Il existe déjà un compte avec cet email',
  home_inscription_error_NICKNAME_EXIST: 'Il existe déjà un compte avec ce pseudo',
  home_inscription_error_EXTERNAL_ID_UNKNOWN: 'Numéro de dossier non reconnu — vérifiez le numéro remis par l\'équipe',
  home_family_title: 'Votre famille',
  home_family_count_fallback: 'Combien de « {{role}} » compte votre famille ?',
  home_inscription_contact_verification_description: 'Saisissez les codes de vérification à 6 chiffres que nous vous avons envoyés pour confirmer vos coordonnées.',
  home_inscription_contact_verified: 'Vérifié',
  home_inscription_contact_verification_success: 'Vos coordonnées ont été vérifiées.',
  home_inscription_email_verification_request_error: 'Erreur lors de l\'envoi du code de vérification par email',
  home_inscription_email_verification_error: 'Erreur lors de la vérification du code email',
  home_inscription_phone_verification_request_error: 'Erreur lors de l\'envoi du code de vérification par SMS',
  home_inscription_phone_verification_error: 'Erreur lors de la vérification du code SMS',

  // Randomisation errors
  home_randomisation_no_slots: "Les inscriptions sont actuellement complètes pour votre groupe. Veuillez réessayer plus tard ou contacter l'équipe de l'étude.",
  home_randomisation_no_matching_group: "Aucun groupe de randomisation ne correspond à votre profil. Veuillez contacter l'équipe de l'étude.",
  home_randomisation_invalid_case_code: 'Ce numéro de dossier est introuvable. Veuillez le vérifier et réessayer.',
  home_randomisation_unsupported: "Cette étude utilise une méthode d'inscription qui n'est pas encore prise en charge. Veuillez contacter l'équipe de l'étude.",
  home_randomisation_site_required: 'Veuillez sélectionner votre site avant de donner votre consentement.',

  // Case code step
  home_case_code_title: 'Numéro de dossier',
  home_case_code_description: 'Saisissez le numéro de dossier qui vous a été communiqué.',
  home_case_code_placeholder: 'Numéro de dossier',

  // Ajout Synakene
  home_welcome: "Bienvenue dans {{appName}}!",
  home_description: "Fais le point avec {{appName}} !",
  home_partners_caption: "Soutenu par",
  home_anonymous_data: "Tes données sont confidentielles, les chercheurs n'auront pas accès à votre identité.",
  home_new: "Êtes-vous nouveau ?",
  home_copy_link: "Copier le lien de l'étude",
  home_copied: "Le lien a bien été copié !",
  not_eligible_but_try_the_app: "Essayer l'application sans participer à l'étude",

  home_not_included: 'Nous vous remercions pour votre intérêt, mais vous n\'êtes pas éligible pour participer à cette étude.',
  home_not_included_desc: 'Pour nous aider, vous pouvez partager l\'étude à votre entourage.',
  home_nir_title: 'Votre numéro de sécurité sociale',
  home_nir_explanation_snds: 'Utilisé uniquement pour relier l’étude au Système National des Données de Santé (SNDS). Chiffré, conservé à part, jamais visible par l’équipe de recherche.',
  home_nir_placeholder: '15 chiffres, tel qu’indiqué sur votre carte Vitale',
  home_nir_input_placeholder: 'ex. 2 85 05 78 006 048 22',
  home_nir_field_label: 'Numéro de sécurité sociale (NIR)',
  home_nir_optional_label: 'Facultatif',
  home_nir_error_conflict: 'Ce numéro de sécurité sociale est déjà associé à un autre participant de l’étude.',
};
